<template>
  <ml-dialog
    ref="dialogRef"
    title="编辑记录"
    width="700px"
    :btnLoading="btnLoading"
    submitText="保存"
    @click-submit="handleSave"
    @click-close="closeHandle"
  >
    <template #body>
      <ml-form
        labelWidth="100px"
        style="width: 100%; padding: 0 24px; box-sizing: border-box"
        :model="editForm"
        :rules="editFormRule"
        ref="editFormRef"
        :label-width="'150px'"
      >
        <!-- 开始时间 -->
        <ml-date-picker
          prop="startTime"
          placeholder="请选择开始时间"
          label="开始时间:"
          type="datetime"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          v-model="editForm.startTime"
        />
        <!-- 结束时间 -->
        <ml-date-picker
          prop="endTime"
          placeholder="请选择结束时间"
          label="结束时间:"
          type="datetime"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          v-model="editForm.endTime"
        />
        <!-- 办结描述 -->
        <ml-input
          prop="content"
          placeholder="请输入内容描述"
          label="内容描述"
          type="textarea"
          :rows="5"
          v-model="editForm.content"
        />
        <el-form-item>
          <template #label>
            <span>安全作业附件</span>
            <el-tooltip content="上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求" placement="top">
              <i class="el-icon-question" style="cursor: pointer; margin-left: 4px"></i>
            </el-tooltip>
          </template>
          <ml-upload
            multiple
            autoUpload
            :showFileList="false"
            :action="action"
            :data="{ linkType: 'error', type: 1 }"
            :headers="{ Authorization: toKen }"
            name="files"
            @on-success="onSafetyUploadSuccess"
          >
            <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
              上传附件
            </el-button>
          </ml-upload>
          <ml-list fileName="fileName" :list="editForm.safetyAttachVos" :showPreview="true" />
        </el-form-item>

        <el-form-item label="日常作业附件" prop="dailyAttachVos">
          <ml-upload
            multiple
            autoUpload
            :showFileList="false"
            :action="action"
            :data="{ linkType: 'error', type: 0 }"
            :headers="{ Authorization: toKen }"
            name="files"
            @on-success="onDailyUploadSuccess"
          >
            <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
              上传附件
            </el-button>
          </ml-upload>
          <ml-list fileName="fileName" :list="editForm.dailyAttachVos" :showPreview="true" />
        </el-form-item>
      </ml-form>
    </template>
  </ml-dialog>
</template>
<script>
import { useStore } from 'vuex'
import { computed, reactive, ref } from 'vue'
import { BASEURL, FILEUPLOADURL } from '@API'
export default {
  name: 'editTaskForm',
  props: {
    inspectTaskId: {
      type: String,
      default: ''
    }
  },
  emits: ['success', 'close'],
  setup(props, context) {
    const { commit, dispatch, getters } = useStore()
    const toKen = computed(() => getters.getToken)
    const dialogRef = ref(null)
    const editFormRef = ref()
    const btnLoading = ref(false)
    const currentRecord = ref(null)
    const isSafetyRemark = remark => typeof remark === 'string' && remark.startsWith('type_')
    const editForm = reactive({
      startTime: '',
      endTime: '',
      content: '',
      safetyAttachVos: [],
      dailyAttachVos: []
    })
    // 校验规则与新增表单保持一致
    const editFormRule = {
      startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
      endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
      content: [{ required: true, message: '请输入描述', trigger: 'blur' }],
      dailyAttachVos: [{ required: true, message: '请上传日常作业附件', trigger: 'change' }]
    }
    // 上传附件
    const action = ref(`${BASEURL}${FILEUPLOADURL}`)
    // 打开编辑弹窗并回填记录数据
    const show = record => {
      currentRecord.value = record
      const attachSource = record.fileList || record.attachVos || []
      editForm.startTime = record.startTime || ''
      editForm.endTime = record.endTime || ''
      editForm.content = record.content || ''
      editForm.safetyAttachVos = attachSource.filter(item => isSafetyRemark(item.remark))
      editForm.dailyAttachVos = attachSource.filter(item => !isSafetyRemark(item.remark))
      dialogRef.value.showDialog = true
    }
    const closeHandle = () => {
      context.emit('close')
    }
    // 安全作业附件上传成功
    const onSafetyUploadSuccess = files => {
      if (files.data) {
        const items = files.data
        const compliantItems = items.filter(item => isSafetyRemark(item.remark))
        const hasNonCompliant = items.some(item => !isSafetyRemark(item.remark))
        if (hasNonCompliant) {
          commit('setError', {
            status: true,
            title: '',
            message: '上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求',
            type: 'error'
          })
        }
        if (compliantItems.length > 0) {
          editForm.safetyAttachVos = [...editForm.safetyAttachVos, ...compliantItems]
        }
      }
    }
    // 日常作业附件上传成功
    const onDailyUploadSuccess = files => {
      if (files.data) {
        editForm.dailyAttachVos = [...editForm.dailyAttachVos, ...files.data]
      }
    }
    // 保存修改
    const handleSave = () => {
      editFormRef.value.CustomFormRef.validate().then(() => {
        const startTime = new Date(editForm.startTime).getTime()
        const endTime = new Date(editForm.endTime).getTime()
        if (startTime > endTime) {
          commit('setError', {
            status: true,
            title: '',
            message: '结束时间不能小于开始时间',
            type: 'error'
          })
          return
        }
        const params = {
          id: currentRecord.value && currentRecord.value.id,
          inspectTaskId: props.inspectTaskId,
          startTime: editForm.startTime,
          endTime: editForm.endTime,
          content: editForm.content,
          fileList: [...editForm.safetyAttachVos, ...editForm.dailyAttachVos]
        }
        btnLoading.value = true
        dispatch('fetchUpdateTaskSubmitRecord', params)
          .then(res => {
            btnLoading.value = false
            if (res && res.code === 200) {
              commit('setError', {
                status: true,
                title: '',
                message: '修改成功',
                type: 'success'
              })
              dialogRef.value.showDialog = false
              context.emit('success')
            }
          })
          .catch(() => {
            btnLoading.value = false
          })
      })
    }
    return {
      dialogRef,
      editFormRef,
      editForm,
      editFormRule,
      action,
      toKen,
      btnLoading,
      show,
      closeHandle,
      onSafetyUploadSuccess,
      onDailyUploadSuccess,
      handleSave
    }
  }
}
</script>
